// extracted by mini-css-extract-plugin
export default {"deprecatedContactDetails":"XqPi2Z9kVEqts8V4skUT","contactDetails":"F8F0ZeZpmmHV0FVpReAu"};